<template>
  <div style="background-color: #f0f0f0;height: 100%;min-height: 765px;">
    <div class="content">
      <el-row>
        <el-col :span="6">
          <div class="c-left">
            <div class="line">
              <span>实用工具</span>
            
            </div>
            <div class="toolbox">
              <div>
                <a target="_blank" href="https://www.wenxianxue.cn/gis/">
                  <img src="../assets/pic-gis.png" alt />
                </a>
              </div>
              <div>
                <a target="_blank" href="https://www.zdic.net/">
                  <img src="../assets/pic-hand.png" alt />
                </a>
              </div>
              <div>
                  <a target="_blank" href="https://www.cnki.net/">
                    <img src="../assets/pic-zhiw.png" alt />
                  </a>
              </div>
              <div>
                 <a target="_blank" href="http://guji.xueheng.net/">
                  <img src="../assets/pic-duik.png" alt />
                 </a>
              </div>
              <div>
                 <a target="_blank" href="http://publish.ancientbooks.cn/docShuju/platformcalendarconversion.jspx">
                  <img src="../assets/pic-nianb.png" alt />
                 </a>
              </div>
              <div>
                  <a target="_blank" href="https://seg.shenshen.wiki/">
                    <img src="../assets/pic-duanj.png" alt />
                  </a>
              </div>
            </div>
          </div>
          <div class="tbox">
            <img src="../assets/dfzhts.png" alt />
          </div>
        </el-col>
        <el-col :span="18">
          <div class="c-right">
            <div class="line">
              <span>资源分类</span>
              <img style="margin-left: 16px" src="../assets/line-750.png" alt />
            </div>
            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  古籍检索
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data1"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>

              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  古籍影像
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data2"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  古籍目录
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data3"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  数字人文
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data4"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  期刊论著
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data5"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  文史诗词
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data6"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  收费平台
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data7"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  小学专题
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data8"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  释道专题
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data9"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" class="elist">
              <el-col :span="3">
                <div class="grid-content bg-purple" style="color: #666666">
                  敦煌专题
                </div>
              </el-col>
              <el-col
                class="bg-purple"
                :span="4"
                v-for="(item, index) in data10"
                :key="index"
              >
                <a
                  class="grid-content bg-purple"
                  target="_blank"
                  :href="item.address"
                  >{{ item.name }}</a
                >
              </el-col>
              <el-col :span="1">
                <div class="grid-content bg-purple">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <div style="height: 10px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      data1: '',
      data2: '',
      data3: '',
      data4: '',
      data5: '',
      data6: '',
      data7: '',
      data8: '',
      data9: '',
      data10: '',
    };
  },
  methods: {},
  created() {
    this.$http
      .get(`${this.$store.state.baseurl}/api/navigation?index=10`)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        this.data1 = obj.data1;
        this.data2 = obj.data2;
        this.data3 = obj.data3;
        this.data4 = obj.data4;
        this.data5 = obj.data5;
        this.data6 = obj.data6;
        this.data7 = obj.data7;
        this.data8 = obj.data8;
        this.data9 = obj.data9;
        this.data10 = obj.data10;
      });
  },
};
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
  color: #000000;
}
a:hover {
  color: red;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.c-left {
  background-color: #ffffff;
  margin: 20px 20px 20px 0;
  display: flex;
  flex-direction: column;
}
.c-right {
  margin: 20px 20px 20px 0;
  .bg-purple {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    text-decoration: none;
    color: #000000;
  }
  .bg-purple :hover {
    color: red;
  }
}
.toolbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  div {
    width: 70px;
    height: 70px;
    margin: 5px 5px 40px 15px;
    border: 1px solid #eae9e9;
    border-radius: 5px;
    font-size: 50px;
    p {
      font-size: 14px;
    }
  }
}
.tbox {
  width: 280px;
  height: 158px;
}
.elist {
  margin-bottom: 25px;
  margin-left: 20px !important;
}

</style>
